import { ApiRoutes, AppPaginationOptions, QueryError, WithPagination } from '@/common/interfaces';
import { apiExecutor, buildMutation, buildQuery } from '@/common/services';

import { Referral, ReferralFormFields, ReferralsQueryKeys } from '@/modules/Sites';

export const useGetAllReferralsQuery = (siteId: string, paginationOptions: AppPaginationOptions) =>
  buildQuery<WithPagination<Referral>, QueryError>([ReferralsQueryKeys.GetAll, siteId, paginationOptions], async () => {
    const { data } = await apiExecutor.get(
      ApiRoutes.Referrals.replace(':siteId', siteId),
      { params: paginationOptions }
    );
    return data;
  });

export const useGetByIdReferralsQuery = (siteId: string, id: string) =>
  buildQuery<Referral, QueryError>([ReferralsQueryKeys.Dossier, siteId, id], async () => {
    const { data } = await apiExecutor.get(
      ApiRoutes.ReferralsById.replace(':siteId', siteId).replace(':referralId', id)
    );
    return data;
  });

export const useCreateReferralsMutation = (siteId: string) =>
  buildMutation<Referral, QueryError, ReferralFormFields>([ReferralsQueryKeys.Create, siteId], async (postData) => {
    const { data } = await apiExecutor.post(ApiRoutes.Referrals.replace(':siteId', siteId), postData);
    return data;
  });

export const useEditReferralsMutation = (siteId: string, id: string) =>
  buildMutation<Referral, QueryError, ReferralFormFields>([ReferralsQueryKeys.Edit, siteId, id], async (postData) => {
    const { data } = await apiExecutor.patch(
      ApiRoutes.ReferralsById.replace(':siteId', siteId).replace(':referralId', id),
      { ...postData, id }
    );
    return data;
  });

export const useDeleteReferralsMutation = (siteId: string, id: string) =>
  buildMutation<void, QueryError, void>([ReferralsQueryKeys.Delete, siteId, id], async () => {
    await apiExecutor.delete<void>(ApiRoutes.ReferralsById.replace(':siteId', siteId).replace(':referralId', id));
  });

export const useBreadcrumbReferralsQuery = (siteId: string, id: string) =>
  buildQuery<string, QueryError>([ReferralsQueryKeys.Breadcrumb, siteId, id], async () => {
    const { data } = await apiExecutor.get(ApiRoutes.ReferralsBreadcrumb.replace(':siteId', siteId).replace(':referralId', id));
    return data;
  });
